document.addEventListener("DOMContentLoaded", showMore);
function showMore() {
  const button = document.querySelector(".policy-btn");
  const list = document.querySelector(".policy-list-hidden");
  button?.addEventListener("click", () => {
    if (list.classList.contains("show")) {
      button.textContent = "Читати більше";
      list.style.maxHeight = null;
      list.classList.remove("show");
    } else {
      button.textContent = "Сховати";
      list.style.maxHeight = list.scrollHeight + "px";
      list.classList.add("show");
    }
  });
}
